/**
 * Shown beneath the totals (and the button is disabled) when the credit note
 * total would exceed the original invoice total and no credit notes have been
 * applied yet. Copy agreed with design.
 */
export const CREDIT_NOTE_EXCEEDS_INVOICE_MESSAGE =
  'Credit note total cannot exceed original invoice amount'

/**
 * Shown instead of CREDIT_NOTE_EXCEEDS_INVOICE_MESSAGE when credit notes have
 * already been applied to the invoice, so the cap is what remains creditable
 * rather than the full invoice amount.
 */
export const CREDIT_NOTE_EXCEEDS_CREDITABLE_MESSAGE =
  'The total credited across all credit notes cannot exceed the original invoice amount'

/**
 * Shown beneath the totals (and the button is disabled) when the credit note
 * total is negative. Matches the credit note detail page's guard, which mirrors
 * the backend finalisation check.
 */
export const CREDIT_NOTE_NEGATIVE_TOTAL_MESSAGE =
  "Credit note total can't be negative"
